






















































































































































import { CharacterInventoryViewObject, EquipmentSlots, ItemTemplateViewObject } from '@/types/apiServerContract';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class InventoryItem extends Vue {
    @Prop({ required: false, default: null })
    inventoryItem!: CharacterInventoryViewObject | null;

    @Prop({ type: Boolean, default: true })
    showTooltip!: boolean;

    @Prop({ type: Number, default: -1 })
    equipmentSlot!: EquipmentSlots;

    @Prop({ type: Boolean, default: false })
    isBagSlot!: boolean;

    @Prop({ type: Boolean, default: false })
    hideIcon!: boolean;

    @Prop({ type: String, default: 'inventory' })
    mode!: string;

    term: string = '';

    get id() {
        return `item-tooltip-${this.mode}-${this.inventoryItem?.guid}-${this.inventoryItem?.guid}-${this.inventoryItem?.count}` + new Date().valueOf();
    }

    get item(): ItemTemplateViewObject | null {
        return this.inventoryItem?.item ?? null;
    }

    get items() {
        const term = this.term.toLowerCase();
        return (term
            ? this.inventoryItem?.items.filter(x => x.item.name.toLowerCase().includes(term) || x.entry.toString() === term)
            : this.inventoryItem?.items) ?? [];
    }

    getItemByBagSlot(slot: number) {
        // Special case for backpack
        if (this.inventoryItem?.guid === 0) {
            slot = slot + 23;
        }

        return this.items.find(x => x.slot === slot - 1);
    }

    get isBag() {
        return this.inventoryItem?.isBag ?? false;
    }

    get isMasterBag() {
        return this.mode === 'master-bag';
    }

    get modalSize() {
        return this.isMasterBag ? 'xl' : 'md';
    }

    get icon() {
        if (this.isBagSlot && !this.item) {
            return 'backpack.png';
        }

        if (!this.item) {
            let icon = '';
            switch (this.equipmentSlot) {
            case EquipmentSlots.EQUIPMENT_SLOT_HEAD:
                icon = 'head.png';
                break;
            case EquipmentSlots.EQUIPMENT_SLOT_NECK:
                icon = 'neck.png';
                break;
            case EquipmentSlots.EQUIPMENT_SLOT_SHOULDERS:
                icon = 'shoulders.png';
                break;
            case EquipmentSlots.EQUIPMENT_SLOT_BODY:
                icon = 'body.png';
                break;
            case EquipmentSlots.EQUIPMENT_SLOT_CHEST:
                icon = 'chest.png';
                break;
            case EquipmentSlots.EQUIPMENT_SLOT_WAIST:
                icon = 'waist.png';
                break;
            case EquipmentSlots.EQUIPMENT_SLOT_LEGS:
                icon = 'legs.png';
                break;
            case EquipmentSlots.EQUIPMENT_SLOT_FEET:
                icon = 'feet.png';
                break;
            case EquipmentSlots.EQUIPMENT_SLOT_WRISTS:
                icon = 'wrist.png';
                break;
            case EquipmentSlots.EQUIPMENT_SLOT_HANDS:
                icon = 'hands.png';
                break;
            case EquipmentSlots.EQUIPMENT_SLOT_BACK:
                icon = 'back.png';
                break;
            case EquipmentSlots.EQUIPMENT_SLOT_MAINHAND:
                icon = 'mainhand.png';
                break;
            case EquipmentSlots.EQUIPMENT_SLOT_OFFHAND:
                icon = 'shield.png';
                break;
            case EquipmentSlots.EQUIPMENT_SLOT_RANGED:
                icon = 'ranged.png';
                break;
            case EquipmentSlots.EQUIPMENT_SLOT_TABARD:
                icon = 'tabard.png';
                break;
            case EquipmentSlots.EQUIPMENT_SLOT_FINGER1:
            case EquipmentSlots.EQUIPMENT_SLOT_FINGER2:
                icon = 'finger.png';
                break;
            case EquipmentSlots.EQUIPMENT_SLOT_TRINKET1:
            case EquipmentSlots.EQUIPMENT_SLOT_TRINKET2:
                icon = 'trinket.png';
                break;
            default:
                icon = 'item_questionmark.png';
                break;
            }

            return icon;
        }

        return `background-image: url('${this.item.icon}');`;
    }

    get itemNameStyle() {
        return `color: ${this.item?.qualityColor};`;
    }

    get buyPrice() {
        if (!this.item) return 0;

        const price = this.item.buyPrice;
        const gold = Math.floor(price / 10000);
        const silver = Math.floor((price % 10000) / 100);
        const copper = (price % 10000) % 100;
        return {
            gold,
            silver,
            copper
        };
    }

    get sellPrice() {
        if (!this.item) return 0;

        const price = this.item.sellPrice;
        const gold = Math.floor(price / 10000);
        const silver = Math.floor((price % 10000) / 100);
        const copper = (price % 10000) % 100;
        return {
            gold,
            silver,
            copper
        };
    }

    get count() {
        return (this.isBag
            ? this.items?.length
            : this.inventoryItem?.count) ?? 1;
    }

    openBag() {
        if (this.isBag) {
            this.$bvModal.show(this.id);
        }
    }
}
